import firstProjectPhoto from "../../assets/img/personal_website.png";
import secondProjectPhoto from "../../assets/img/project_wolftrading.png";

export const projects = [
  {
    id: 1,
    photo: firstProjectPhoto,
    title: "Personal portfolio",
    text: "Tech\u00A0stack: React, Styled-Components, Git",
    github: "https://github.com/agnieszkaole/personal-website-react",
    live: "https://portfolio-react-two-theta.vercel.app/",
  },

  {
    id: 2,
    photo: secondProjectPhoto,
    title: "Forex trader website",
    text: "Tech\u00A0stack: HTML, Sass, Javascript, Jquery, Git",
    github: "https://github.com/agnieszkaole/wolftrading-website",
    live: "https://wolftrading-website.vercel.app/",
  },
];
